import { PdsrClientViewModel } from "../ViewModel/PdsrClientViewModel";
import { ProjectStateType } from "./EditProjectContext";
import { FtlRouteViewModel } from "../ViewModel/FtlRouteViewModel";
import { updatePdsrFTLIdentifier } from "./handleCardOnDragEnd/updatePdsrFTLIdentifier";

export const setPdsrsOnThisRoute = (
  routeId: number,
  items: Array<PdsrClientViewModel>,
  { project, setProject }: ProjectStateType
) => {
  const updateFtlRoute = (ftlRouteItem: FtlRouteViewModel) => {
    return ftlRouteItem.RouteId === routeId
      ? {
          ...ftlRouteItem,
          PdsrsOnThisRoute: items,
        }
      : ftlRouteItem;
  };

  setProject(
    updatePdsrFTLIdentifier({
      ...project,
      FTLRoutes: project?.FTLRoutes?.map(updateFtlRoute),
    })
  );
};
